import './TabContent.less';
import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Scrollbar } from '@beehive/components';

export interface TabContentProps {
  className?: string;
  tabKey: string;
  bottom?: React.ReactNode;
  canScroll?: boolean;
  resizeAble?: boolean;
}

export default class TabContent extends React.Component<TabContentProps, any> {
  private tabcontentRef: React.RefObject<any> = React.createRef();
  public static contextTypes = {
    prefixCls: PropTypes.string,
  };

  private scrollToBottom = () => {
    if (this.tabcontentRef.current) {
      setTimeout(() => {
        this.tabcontentRef.current.getRef().scrollToBottom();
      }, 200);
    }
  }

  public render() {
    const { className, tabKey, children, bottom, canScroll, resizeAble = false } = this.props;
    const { prefixCls } = this.context;
    const classes = classNames(className, `${prefixCls}-tab-content`, `${prefixCls}-tab-content-${tabKey}`);
    const wrapperClasses = classNames(`${prefixCls}-tab-content-wrapper`, {
      [`${prefixCls}-tab-content-wrapper-scroll-part`]: canScroll,
    });
    return (
      <div className={classes}>
        {!!children &&
          (canScroll ? (
            <Scrollbar className={wrapperClasses} autoHeight ref={this.tabcontentRef}>{children}</Scrollbar>
          ) : (
            <div className={wrapperClasses}>{children}</div>
          ))}
        {!!bottom && <div className={`${prefixCls}-tab-content-bottom clear-fix`}>{bottom}</div>}
      </div>
    );
  }
}
